import PropTypes from 'prop-types';

function MMPetsActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M9.58298 13.6252C9.58298 13.6252 7.78596 25.1775 8.3379 25.6481C8.88984 26.1188 13.4722 28.2752 22.0936 26.3027C29.0464 24.7111 32.8929 22.0712 34.2577 19.8035C34.8097 19.1617 28.4816 9.23535 28.4816 9.23535L9.58298 13.6252Z"
                fill="#F2D79A"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M19.7594 14.6201C24.9711 13.4121 28.8655 11.0071 28.4579 9.24834C28.0502 7.48962 23.4948 7.04318 18.2831 8.25119C13.0714 9.45919 9.17699 11.8642 9.58464 13.6229C9.99229 15.3816 14.5477 15.8281 19.7594 14.6201Z"
                fill="white"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M24.5284 18.9179C24.8467 18.8443 25.136 18.678 25.3597 18.4399C25.5835 18.2019 25.7316 17.9029 25.7854 17.5807C25.8392 17.2585 25.7962 16.9276 25.6619 16.6298C25.5276 16.332 25.308 16.0807 25.0309 15.9078C24.7538 15.7348 24.4316 15.6479 24.1051 15.658C23.7785 15.6682 23.4624 15.7749 23.1965 15.9648C22.9307 16.1546 22.7271 16.419 22.6116 16.7246C22.496 17.0301 22.4737 17.3631 22.5474 17.6814C22.5683 17.7726 22.5984 17.8615 22.6373 17.9466L17.9308 19.0377C17.9242 18.9442 17.9114 18.8513 17.8923 18.7596C17.8177 18.4504 17.6553 18.1693 17.4248 17.9501C17.1943 17.7309 16.9054 17.583 16.5929 17.524C16.2803 17.4651 15.9574 17.4976 15.6629 17.6178C15.3684 17.738 15.1148 17.9406 14.9327 18.2014C14.7506 18.4622 14.6477 18.77 14.6363 19.0879C14.6249 19.4057 14.7056 19.7201 14.8686 19.9933C15.0316 20.2664 15.27 20.4867 15.5551 20.6276C15.8403 20.7685 16.1601 20.8241 16.476 20.7876C16.1732 20.8906 15.9068 21.0793 15.7092 21.3308C15.5116 21.5823 15.3912 21.8858 15.3628 22.2043C15.3343 22.5229 15.399 22.8429 15.5489 23.1255C15.6989 23.408 15.9276 23.6409 16.2074 23.7959C16.4872 23.9509 16.806 24.0213 17.125 23.9986C17.4441 23.9759 17.7497 23.861 18.0047 23.668C18.2597 23.4749 18.4531 23.2119 18.5615 22.911C18.67 22.6101 18.6886 22.2841 18.6154 21.9728C18.5939 21.8822 18.5653 21.7935 18.5298 21.7075L23.2363 20.6165C23.2431 20.7099 23.2559 20.8028 23.2748 20.8946C23.3484 21.2129 23.5147 21.5022 23.7527 21.7259C23.9907 21.9496 24.2897 22.0978 24.6119 22.1516C24.9341 22.2054 25.2651 22.1624 25.5629 22.0281C25.8606 21.8938 26.1119 21.6742 26.2849 21.3971C26.4579 21.1199 26.5448 20.7978 26.5346 20.4713C26.5245 20.1447 26.4177 19.8286 26.2279 19.5627C26.038 19.2969 25.7736 19.0933 25.468 18.9778C25.1625 18.8622 24.8295 18.8399 24.5113 18.9136L24.5284 18.9179Z"
                fill="#DC6C31"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.0488 15.2511C13.451 14.4681 18.0462 10.1809 25.4568 12.3758C19.6251 15.6533 13.0488 15.2511 13.0488 15.2511Z"
                fill="#2D2D2D"
            />
        </svg>
    );
}

export default MMPetsActive;

MMPetsActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

MMPetsActive.defaultProps = {
    className: null,
};
